import React from 'react';
import {Button} from "react-bootstrap";

function CustomButton(props) {
    return (
        <div className={"d-grid gap-2 custom-button "+ props.className} style={props.style} >
            <Button type={props.type} className={"btn btn- btn-success " + props.className} onClick={props.onClick} >
                {props.children}
            </Button>
        </div>
    );
}

export default CustomButton;
